import store from "@/store";
import { getMultiTemplateAuth, errorToast } from '@template/utils';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const walletRoutes = ['Wallet', 'WalletDeposit', 'WalletWithdraw', 'WalletHistory', 'TransactionDetails', 'DepositPaymentMethod', 'WithdrawDetails', 'WithdrawAccountDetails'];

export const routerGuard = async (to, from, next) => {
    try {
        const siteSettings = store.getters.siteSettings;
        const auth = store.getters.isAuthenticated;
        
        if(to.query.auth && !auth) {
            await getMultiTemplateAuth(to);
            cookies.set('AUTH_TOKEN', to.query.auth);
            return next({ name: 'Home' })
        }
        const isDemoUser = store.getters?.stateUser?.isDemo;
        const underMaintenance = store.getters.underMaintenance;
        const isMaintenancePage = to.name === 'Maintenance';
        const modalInstance = document.querySelector('.modal.show')
        const isLandingPage = siteSettings?.is_landing_page;
        const lpRoutes = ['LandingPage', 'Login', 'SignUp', 'ForgotPassword'];
        
        if (underMaintenance) {
            if (!isMaintenancePage) {
                return next({ name: 'Maintenance' });
            } else {
                return next();
            }
        } else {
            if (isMaintenancePage) {
                return next({ name: 'Home' });
            } else {
                if(modalInstance && modalInstance.id != 'success_submit'){
                    return next(false);
                }
                if (isDemoUser && walletRoutes.includes(to.name)) {
                    errorToast('Wallet Access Is Restricted For Demo User.');
                    return next({ name: 'Home' });
                }
                if(siteSettings) {
                    if(isLandingPage && !auth && !lpRoutes.includes(to.name)) {
                        return next({name : 'LandingPage'});
                    } else if(auth && lpRoutes.includes(to.name)) {
                        return next({name : 'Home'});
                    } else if(isLandingPage && !auth && to.name == 'Home') {
                        return next({name : 'LandingPage'});
                    } else if(isLandingPage && !auth && lpRoutes.includes(to.name)) {
                        return next();
                    } else if(!isLandingPage && !auth && to.name == 'LandingPage') {
                        return next({name : 'Home'});
                    } else {
                        return next();
                    }
                } else {
                    return next();
                }
            }
        }
    } catch (e) {
        console.log(e);
    } finally {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }, 500);
    }

};